import React from 'react';

import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';

const Services = () =>{
    return(
<section id="services" class="services section-bg">
      <div class="container">

        <div class="section-title" data-aos="">
          <h2>Services</h2>
          <p>Boost your business' digital presence in India with web and mobile apps.  eMarketers estimates that Indians spend an hour and 39 minutes online each day. Would you like to take advantage of the growing digital trend? It's time to get started if you haven't already. SpireWeb Technologies or our team helps you build a strong digital presence across mobile and web. From product development to marketing, we are your one-stop destination for all your digital needs.</p>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="">
            <div class="icon-box icon-box-pink">
              <div class="icon"><i class="bx bxl-dribbble"></i></div>
              <h4 class="title"><a href="">Website Design</a></h4>
              <p class="description">By creating engaging websites, we can help you build brand awareness, acquire new customers, and provide excellent customer service.</p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="" data-aos-delay="100">
            <div class="icon-box icon-box-cyan">
              <div class="icon"><i class="bx bx-file"></i></div>
              <h4 class="title"><a href="">Customized Web App Development</a></h4>
              <p class="description">With our developers experience in Web app development, we can offer you a wide range of Customized Web application development services.</p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="" data-aos-delay="200">
            <div class="icon-box icon-box-green">
              <div class="icon"><i class="bx bx-tachometer"></i></div>
              <h4 class="title"><a href="">Mobile App Development</a></h4>
              <p class="description">With experience in Android app development in Kotlin (Programming Language) and Android Studio, we can offer you a wide range of Android application development services.</p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="" data-aos-delay="300">
            <div class="icon-box icon-box-blue">
              <div class="icon"><i class="bx bx-world"></i></div>
              <h4 class="title"><a href="">E-Commerce Development</a></h4>
              <p class="description">Providing the best Ecommerce services is our specialty. Boost your business online</p>
            </div>
          </div>

        </div>
<br />
        <div class="row">
          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="">
            <div class="icon-box icon-box-pink">
              <div class="icon"><i class="bx bxl-dribbble"></i></div>
              <h4 class="title"><a href="">Bulk SMS/Voice Calls</a></h4>
              <p class="description">We can help to you best service like Bulk SMS and Voice Calls in OTP and other confirmation messages for your business</p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="" data-aos-delay="100">
            <div class="icon-box icon-box-cyan">
              <div class="icon"><i class="bx bx-file"></i></div>
              <h4 class="title"><a href="">SEO/SMO</a></h4>
              <p class="description">We help you make the most of your business digital marketing services.</p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="" data-aos-delay="200">
            <div class="icon-box icon-box-green">
              <div class="icon"><i class="bx bx-tachometer"></i></div>
              <h4 class="title"><a href="">Branding and Promotions</a></h4>
              <p class="description">We offer to that grow your business digitally with us.</p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0" data-aos="" data-aos-delay="300">
            <div class="icon-box icon-box-blue">
              <div class="icon"><i class="bx bx-world"></i></div>
              <h4 class="title"><a href="">Many More</a></h4>
              <p class="description"> We can help to you providing service globally </p>
            </div>
          </div>

        </div>

      </div>
    </section>
    );
}


export default Services;